import * as Immutable from 'immutable';
import * as ActionTypes from '../constants/ActionTypes';
import Place from '../records/place';
import Contact from '../records/contact';
import Hour from '../records/hour';

const hoursOptions = [new Hour(), new Hour()];

const hours = {
  monday     :hoursOptions.map(h => h.set('day', 'Monday')),
  tuesday    :hoursOptions.map(h => h.set('day', 'Tuesday')),
  wednesday  :hoursOptions.map(h => h.set('day', 'Wednesday')),
  thursday   :hoursOptions.map(h => h.set('day', 'Thursday')),
  friday     :hoursOptions.map(h => h.set('day', 'Friday')),
  saturday   :hoursOptions.map(h => h.set('day', 'Saturday')),
  sunday     :hoursOptions.map(h => h.set('day', 'Sunday'))
};

const businessPhone = new Contact({ type: 'phone' });
const businessEmail = new Contact({ type: 'email' });
const contactPhone = new Contact({ type: 'phone' });
const contactEmail = new Contact({ type: 'email' });
const contactWebsite = new Contact({ type: 'website' });
const businessPlace = new Place();
const contactPlace = new Place({ hidden: true });

const planState = Immutable.fromJS({
  step: 1,
  saving: false,
  plan: '',
  businessPlace: businessPlace,
  businessPhone: businessPhone,
  businessEmail: businessEmail,
  contactPhone: contactPhone,
  contactEmail: contactEmail,
  contactPlace: contactPlace,
  url: contactWebsite,
  contact_title: '',
  logo: '',
  photos: [],
  instagram_photos: [],
  price: '',
  cuisine: '',
  hours: hours,
  editing_hours: hours,
  tags: [],
  editing_tags: [],
  delete_images: []
});

function setState(state, newState) {
  return state.merge(newState);
}

export function plan(state = planState, action) {
  switch(action.type) {
    case ActionTypes.SAVING_PLAN:
      return setState(state, state.set('saving', action.value));

    case ActionTypes.SET_PLAN:
      return setState(state, state.set('plan', action.plan));

    case ActionTypes.SET_STEP:
      return setState(state, state.set('step', action.step));

    case ActionTypes.SET_ACCOUNT_INFO:
      return setState(state, state.withMutations(map => map
        .setIn(['contactEmail', 'text'], action.payload.contactEmail)
        .setIn(['contactPhone', 'text'], action.payload.contactPhone)
        .set('contact_title', action.payload.contactTitle)
        .setIn(['contactPlace', 'name'], action.payload.contactName)
        .setIn(['contactPlace', 'line1'], action.payload.contactAddress1)
        .setIn(['contactPlace', 'line2'], action.payload.contactAddress2)
        .setIn(['contactPlace', 'locality'], action.payload.contactCity)
        .setIn(['contactPlace', 'region'], action.payload.contactState)
        .setIn(['contactPlace', 'postal_code'], action.payload.contactZip)
      ));

    case ActionTypes.SET_BUSINESS_INFO:
      return setState(state, state.withMutations(map => map
        .setIn(['businessEmail', 'text'], action.payload.businessEmail)
        .setIn(['businessPhone', 'text'], action.payload.businessPhone)
        .setIn(['url', 'text'], action.payload.url)
        .setIn(['businessPlace', 'name'], action.payload.businessName)
        .setIn(['businessPlace', 'line1'], action.payload.businessAddress1)
        .setIn(['businessPlace', 'line2'], action.payload.businessAddress2)
        .setIn(['businessPlace', 'locality'], action.payload.businessCity)
        .setIn(['businessPlace', 'region'], action.payload.businessState)
        .setIn(['businessPlace', 'postal_code'], action.payload.businessZip)
      ));

    case ActionTypes.REPLACE_BUSINESS_INFO:
      const place = action.payload.places().first();

      return setState(state, state.withMutations(map => map
        .set('businessEmail', place.contacts('email').first() || new Contact({ type: 'email' }))
        .set('businessPhone', place.contacts('phone').first() || new Contact({ type: 'phone' }))
        .set('url', place.contacts('website').first() || new Contact({ type: 'website' }))
        .set('businessPlace', place)
      ));

    case ActionTypes.SET_LOGO:
      return setState(state,
        state.merge({
          logo: action.logo
        })
      );

    case ActionTypes.SET_PHOTOS:
      return setState(state, state.set('photos', action.photos));

    case ActionTypes.SET_INSTAGRAM_PHOTOS:
      return setState(state, state.set('instagram_photos', action.instagram_photos));

    case ActionTypes.SET_DETAILS:
      return setState(state, state.withMutations(map => map
        .set('price', action.payload.price)
        .set('cuisine', action.payload.cuisine)
        .set('hours', action.payload.hours)
        .set('editing_hours', action.payload.editing_hours)
        .set('tags', action.payload.tags)
        .set('editing_tags', action.payload.editing_tags)
      ));

    case ActionTypes.UPDATE_HOURS:
      const hours = action.payload.map(h => h.map(j => {
        if (j.id && !j.open) j.set('id', null);
        return j;
      }));

      return setState(state, state.withMutations(map => map
        .set('hours', hours)
        .set('editing_hours', hours)
      ));

    case ActionTypes.UPDATE_HOURS_EDIT_STATE:
      return setState(state, state.setIn(
        ['editing_hours', action.payload.day, action.payload.key, action.payload.type],
        action.payload.time ? action.payload.time.format('HH:mm') : null)
      );

    case ActionTypes.RESET_HOURS_EDIT_STATE:
      if (action.payload.day) {
        return setState(state, state.withMutations(map => map
          .setIn(['editing_hours', action.payload.day, 0, 'open'], null)
          .setIn(['editing_hours', action.payload.day, 0, 'close'], null)
          .setIn(['editing_hours', action.payload.day, 1, 'open'], null)
          .setIn(['editing_hours', action.payload.day, 1, 'close'], null)
        ));
      } else {
        return setState(state, state.get('editing_hours'), planState.get('editing_hours'));
      }

    case ActionTypes.RESET_PLAN:
      return state = planState;

    case ActionTypes.RESET_TAGS:
      state = state.set('editing_tags', Immutable.fromJS([]));
      return setState(state, state.set('tags', Immutable.fromJS([])));

    case ActionTypes.UPDATE_TAGS:
      return setState(state, state.withMutations(map => map
        .set('tags', Immutable.fromJS(action.payload))
        .set('editing_tags', Immutable.fromJS(action.payload))
      ));

    case ActionTypes.UPDATE_TAGS_EDIT_STATE:
      return setState(state, state.set('editing_tags', Immutable.fromJS(action.tags)));

    case ActionTypes.SET_DELETE_IMAGES:
      return setState(state, state.set('delete_images', Immutable.fromJS(action.delete_images)))

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/plan.js